<template>
  <div>
    <vue-good-table
      :line-numbers="true"
      :columns="columns"
      :rows="rows"
      :total-rows="total"
      :sort-options="{ enabled: true }"
      :pagination-options="{ enabled: true }"
      style-class="vgt-table border-0 table-auto"
      @on-sort-change="$emit('sort-change', $event)"
      @on-page-change="$emit('page-change', $event)"
      @on-per-page-change="$emit('per-page-change', $event)"
    >
      <div slot="emptystate" class="text-center font-size-14">No data available</div>

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'action'" class="d-flex justify-content-center align-items-center">
          <b-button class="no-wrap btn-pill" variant="warning" size="sm" title="Update" @click="$emit('update', props.row)">
            <span class="fe fe-edit"></span>
          </b-button>

          <b-button class="no-wrap ml-2" variant="info" size="sm" title="Details" @click="$emit('view', props.row)">
            <span class="fe fe-eye"></span>
          </b-button>

          <b-button
            class="no-wrap ml-2"
            variant="success"
            size="sm"
            title="Duplicate"
            @click="$emit('duplicate', props.row)"
          >
            <span class="fe fe-copy"></span>
          </b-button>

          <b-button class="no-wrap ml-2" variant="danger" size="sm" title="Delete" @click="$emit('delete', props.row)">
            <span class="fe fe-trash-2"></span>
          </b-button>
        </span>
      </template>

      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between align-items-center mt-3 px-3">
          <div class="text-muted">
            Showing
            <strong>{{ showingFrom }} - {{ showingTo }}</strong>
            of <strong>{{ total }}</strong> items
          </div>

          <b-pagination
            v-model="page"
            :total-rows="total"
            :per-page="pageSize"
            first-number
            last-number
            align="right"
            size="md"
            @change="$emit('page-change-from-bv', $event)"
          />
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
export default {
  name: "NotificationEventTable",
  props: {
    rows: Array,
    total: Number,
    showingFrom: Number,
    showingTo: Number,
    page: Number,
    pageSize: Number,
  },

  data() {
    return {
      columns: [
        {
          label: "Name",
          field: "name",
          sortable: true,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Tenant",
          field: "tenant",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Trigger",
          field: "trigger_name",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Module",
          field: "module_type_name",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold w-action",
          tdClass: "color-secondary text-center",
        },
      ],
    };
  },
};
</script>

<style scoped>
.w-action {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
}

.vgt-table.table-auto table {
  table-layout: auto !important;
}

:deep(.table-header) {
  font-size: 12px !important;
}

:deep(.vgt-table td, .vgt-table th) {
  font-size: 12px !important;
}
</style>
